import React, { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import useForm from 'hooks/useForm';
import { Col } from 'components/Base/Grid';
import LoginFooter, { ButtonGroup } from 'components/Shared/LoginFooter';
import TextLink, { ETextLinkColors } from 'components/Base/TextLink';
import { RoutesPaths } from 'routes/Routes.types';
import {
  TLoginPhoneNumberData,
  TLogInPhoneNumberProps,
  EFormIds,
} from 'pages/public/Login/Login.types';
import Form from './components/Form';

const LogInForm = ({
  onSubmit = () => {
    /* do nothing */
  },
  onViaChanged = () => {
    /* do nothing */
  },
  userCredential,
  isLoading,
}: TLogInPhoneNumberProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { form } = useForm<TLoginPhoneNumberData>();

  const handleLogin = async () => {
    const values = await form.validateFields();
    try {
      onSubmit(values);
    } catch (e) {
      // do nothing
    }
  };

  useEffect(() => {
    if (userCredential.phoneNumber) {
      searchParams.delete('username');
      searchParams.delete('pass');
      navigate({
        pathname: location.pathname,
        search: searchParams.toString(),
      });
      if (userCredential.password) {
        handleLogin();
      }
    }
  }, []);

  return (
    <Col>
      <Form form={form} userCredential={userCredential} />
      <TextLink
        linkText="Reset it here"
        to={{
          pathname: `/${RoutesPaths.RESET_PASSWORD}`,
          search: location.search,
        }}
        state={{ viaEmail: false }}
        type={ETextLinkColors.LIGHT_GREY}
        fontLevel={5}
        className="mb-6"
      >
        Forgot password?
      </TextLink>
      <LoginFooter
        mode="LOGIN"
        onClick={handleLogin}
        loading={isLoading}
        formId={EFormIds.PHONE_LOGIN}
      >
        <ButtonGroup onChangeVia={onViaChanged} mode="LOGIN" via="PHONE" />
      </LoginFooter>
    </Col>
  );
};

export default LogInForm;
